import { render, staticRenderFns } from "./ErrorMobile.vue?vue&type=template&id=02c16e7c&scoped=true&lang=html&"
import script from "./ErrorMobile.vue?vue&type=script&lang=ts&"
export * from "./ErrorMobile.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorMobile.vue?vue&type=style&index=0&id=02c16e7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c16e7c",
  null
  
)

export default component.exports